import React from 'react';
import PropTypes from 'prop-types';
import { Field } from 'redux-form';
import { RenderField, RenderHiddenField } from '../../../../common/form';
import * as Validations from '../../../../common/form/commonValidations';


function RsvpQuestions({ questions }) {
  return (
    <div>
      <p className="margin-bottom-2x">The couple would like to know...</p>
      <ul className="list-unstyled rsvp-questions">
        {questions.map(question => (
          <li key={question.id} className="rsvp-question">
            <Field
              id={`rsvp-question-${question.id}-id`}
              name={`rsvp_answers[${question.id}].rsvp_question_id`}
              type="hidden"
              component={RenderHiddenField}
              required
              validate={Validations.REQUIRED}
            />
            <Field
              id={`rsvp-question-${question.id}-answer`}
              name={`rsvp_answers[${question.id}].answer`}
              type="text"
              component={RenderField}
              label={question.question}
              className="rsvp-question-field"
              maxChars={800}
              validate={Validations.MAX_LENGTH_800}
              placeholder="Type your response here."
            />
          </li>
        ))}
      </ul>
    </div>
  );
}

RsvpQuestions.propTypes = {
  questions: PropTypes.arrayOf(
    PropTypes.shape({
      id: PropTypes.number,
      question: PropTypes.string,
    })
  ),
};

export default RsvpQuestions;



/** WEBPACK FOOTER **
 ** ./src/components/PublicWebsite/pages/rsvpV2/RsvpForm/RsvpQuestions.jsx
 **/